module.exports = __webpack_public_path__ + "static/img/zhibo1.84b55419.webp";